import { render, staticRenderFns } from "./LockersContracts.vue?vue&type=template&id=1fc3c041&"
import script from "./LockersContracts.vue?vue&type=script&lang=ts&"
export * from "./LockersContracts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports